@if (isLoadedInitialData) {
  <app-side-panel
    [table]="TABLES.ASSIGN"
    [printOptionActions]="sidePanelPrintActions"
    [drawer]="drawer"
    [showFraud]="true"
    [isPickingMode]="isPickingMode"
    (onSyncOrder)="reSyncOrderClick($event, true)"
    (changeColorCoding)="changeColorCoding($event)"
    (changeColorCodingDisplay)="changeColorCodingDisplay($event)"
    (detectChildChanges)="detectChildChanges($event)"
    #sidePanel>
  </app-side-panel>
  <mat-drawer-container class="assign_screen" (backdropClick)="closeSidePanel(drawer)">
    <mat-drawer-content>
      <div [ngClass]="loading ? 'disabledbtn' : ''">
        <div class="assign_screen__title">{{ screenTitle }}</div>
        <div class="assign_screen__tabs">
          <pdq-tabs-group (onChange)="onChangeFilter($event)">
            @if (useCursorPagination()) {
              <pdq-tab
                [value]="FilterTypes.READY"
                [label]="cappedReadyLabel()"
                [loading]="deliverCursorPagination.tabCountersLoading()"></pdq-tab>
              <pdq-tab
                [value]="FilterTypes.HOLD"
                [label]="cappedHoldLabel()"
                [loading]="deliverCursorPagination.tabCountersLoading()"></pdq-tab>
              <pdq-tab
                [value]="FilterTypes.SCHEDULE"
                [label]="cappedScheduledLabel()"
                [loading]="deliverCursorPagination.tabCountersLoading()"></pdq-tab>
            } @else {
              <pdq-tab
                [value]="FilterTypes.READY"
                label="{{ FilterTypes.LABEL_READY }} ({{ countReadyOrders$ | async }})"></pdq-tab>
              <pdq-tab
                [value]="FilterTypes.HOLD"
                label="{{ FilterTypes.LABEL_PAUSE }} ({{ countHoldOrders$ | async }})"></pdq-tab>
              <pdq-tab
                [value]="FilterTypes.SCHEDULE"
                label="{{ FilterTypes.LABEL_SNOOZE }} ({{ countScheduleOrders$ | async }})"></pdq-tab>
            }
          </pdq-tabs-group>
        </div>
        <div class="assign_screen__tabs-lower">
          <div class="assign_screen__edit-column">
            <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
            <mat-select
              #editcolumns
              (click)="openedChange($event)"
              class="table-columns-select"
              panelClass="pdq-mat-select--panel__multi"
              floatlLabel="never"
              [(ngModel)]="selectedColumns"
              (selectionChange)="toggleColumn()"
              [disableOptionCentering]="true"
              multiple
              matTooltipClass="pdq-mat-tooltip"
              [matTooltip]="'Edit columns'">
              <div class="pdq-mat-select--panel--header">
                Showing {{ selectedColumns.length + '/' + columnsOptions.length }} columns
              </div>
              @for (column of columnsOptions; track column) {
                <mat-option selected="selected" [value]="column.prop">
                  {{ column.name }}
                </mat-option>
              }
            </mat-select>
            <div class="assign_screen__group">
              @if (filter !== FilterTypes.SCHEDULE && filter !== FilterTypes.HOLD) {
                <app-assign-group-by
                  [disable]="aFilter?.length"
                  (groupChanged)="groupChanged($event)"></app-assign-group-by>
              }
            </div>
            <div class="assign_screen__advanced-filter">
              @if (shopId) {
                <app-advanced-filters
                  #advancedFiltersComponent
                  [activeAdvancedFilter]="filter"
                  [advancedFilters$]="advancedFilters$"
                  [disable]="groupBy?.length"
                  (changeFilter)="onChangeFilter($event)"
                  (onClearAdvancedFilter)="toClearAdvancedFilters($event)"
                  [shopId]="shopId"
                  [isTrialMode]="isShopInTrialMode">
                </app-advanced-filters>
              }
            </div>
            <div>
              @if (shopId && filter !== FilterTypes.SCHEDULE && filter !== FilterTypes.HOLD) {
                <app-mentions-filter-btn
                  (onMentionFilterChanged)="onMentionFilterChanged($event)"></app-mentions-filter-btn>
              }
            </div>
          </div>
          <div class="assign_screen__search">
            <app-newui-search-autocomplete
              #searchAutocompleteRef
              (searchResultsToTable)="onSearchToTable($event)"
              [table]="TABLES.ASSIGN"
              [tabFilter]="tabFilter"
              [isPickingMode]="isPickingMode"
              [showDeletedOrders]="false">
            </app-newui-search-autocomplete>
          </div>
        </div>
        @if (displayTable) {
          <div class="assign-table-container">
            @if (!virtualizeGroupBy() || !groupedRows()?.length) {
              <app-table
                hotKeyShortcut
                [relevantShortcuts]="keyboardShortcuts"
                [shortcutScope]="shortcutScope"
                [table]="TABLES.ASSIGN"
                [rows]="temp"
                [displayPickList]="true"
                [columnsSettings]="columns"
                [rowsLoading]="loading"
                [rowActions]="rowActions"
                [focusedRowId]="focusedOrderId"
                [groupActions]="groupActions"
                [totalCountOrders]="totalCountOrders"
                [perPageActiveOption]="ordersPerPage"
                [allPages]="allPages"
                [activePage]="activePage"
                [totalPages]="totalPages"
                [perPageOptions]="perPageOptions"
                [printOptionActions]="tablePrintActions"
                [selected]="selected"
                [isSyncingOrders]="isSyncing"
                [unHold]="unhold"
                [unSchedule]="unschedule"
                [message]="chooseEmptyMessage()"
                (sort)="sortColumns($event)"
                (changeFilter)="onChangeTableFilter($event)"
                (changeSelectedOrders)="onSelect($event)"
                (deleteOrder)="onDeleteOrder($event)"
                (reSyncOrder)="reSyncOrderClick($event)"
                (changePerPage)="onChangeOrdersPerPage($event)"
                (changePage)="paginate($event)"
                (jumpToPage)="jumpToPage($event)"
                (onTableActivate)="onTableActivate($event)"
                (reSyncSelectedOrder)="reSyncSelectedOrderClick()"
                (deleteSelectedOrder)="onDeleteSelectedOrders()"
                (toScheduleSelectedOrders)="toScheduleSelectedOrders()"
                (exportSelectedOrders)="exportSelectedOrders($event)"
                (onBulkPrint)="onBulkPrint($event)"
                (onBottomScrolled)="onBottomScrolled($event)"
                (selectOrderGroupActions)="toSelectedOrderActions($event)"
                (splitOrder)="splitOrder($event)"
                [disableGroupActions]="disableGroupActions"
                (changeLocationSelectedOrders)="changeLocationSelectedOrders($event)"
                [groupRowsBy]="groupBy"
                [groupExpansionDefault]="groupBy?.length"
                (editPackageOrders)="editPackageOrders()"
                (mergeOrders)="mergeOrders()"
                (addTagSelectedOrders)="addTagSelectedOrders()"
                (onBulkColorCodingApply)="bulkChangeColorCoding($event)"
                (changeColorCoding)="changeColorCoding($event)"
                [paginationMode]="useCursorPagination() ? 'cursor' : 'offset'"
                [cursorRangeLabel]="deliverCursorPagination.rangeLabel()"
                [cursorHasNextPage]="deliverCursorPagination.hasNextPage()"
                [cursorHasPreviousPage]="deliverCursorPagination.hasPreviousPage()"
                [totalCountDisplay]="useCursorPagination() ? deliverCursorPagination.totalCountDisplay() : null"
                (cursorPageChange)="onCursorPageChange($event)"></app-table>
            } @else {
              <div class="group-by-container">
                <!-- Header only table -->
                <div class="groups-container">
                  <ng-container
                    [ngTemplateOutletContext]="{
                      rowsLoading: loading,
                      headerOnly: true,
                      rows: rows,
                      allowResetFilters: false,
                    }"
                    [ngTemplateOutlet]="groupByTableTemplate"></ng-container>

                  <div class="groups-scrollable">
                    @for (group of groupedRows(); track group.key; let i = $index) {
                      <pdq-collapsed
                        [initialCollapsed]="groupCollapseState()[group.key]"
                        (onChange)="onCollapseGroupChanged($event, group)"
                        id="group-{{ i }}"
                        appViewportVisibility
                        [viewportMargin]="'1000px'"
                        (visibilityChange)="onGroupVisibilityChanged($event, group.key)">
                        <div class="group-header-wrapper" [class.collapsed]="groupCollapseState()[group.key]">
                          <pdq-collapsed-header>
                            <ng-container *ngTemplateOutlet="groupHeader; context: { $implicit: group }"></ng-container>

                            <pdq-collapsed-trigger
                              [class.collapsed]="groupCollapseState()[group.key]"
                              class="group-trigger">
                              @if (groupedRows().length > 1) {
                                <pdq-icon size="x-large" icon="arrow_down" color="var(--on-surface-light)"></pdq-icon>
                              }
                            </pdq-collapsed-trigger>
                          </pdq-collapsed-header>
                        </div>
                        <pdq-collapsed-content>
                          <!-- Separate table for each group - only render if any part of group is visible -->

                          <div
                            [style.height.px]="
                              groupedRows().length > 1 ? (group | calculateGroupTableHeight: 500) : undefined
                            "
                            [style.overflow]="'hidden'">
                            @if (groupVisibilityState()[group.key]) {
                              <ng-container
                                [ngTemplateOutletContext]="{
                                  headless: true,
                                  collapsed: groupCollapseState()[group.key],
                                  displayFooter: false,
                                  tableHeight:
                                    groupedRows().length > 1 ? (group | calculateGroupTableHeight: 500) : undefined,
                                  rows: group.rows ?? [],
                                }"
                                [ngTemplateOutlet]="groupByTableTemplate"></ng-container>
                            }
                          </div>
                        </pdq-collapsed-content>
                      </pdq-collapsed>
                    }
                  </div>
                </div>
                <!-- Footer only table -->
                <ng-container
                  [ngTemplateOutlet]="groupByTableTemplate"
                  [ngTemplateOutletContext]="{ footerOnly: true, rows: [] }">
                </ng-container>
              </div>
            }
          </div>
        } @else {
          <app-main-loader-lottie></app-main-loader-lottie>
        }
        <app-action-container
          [isBottomScrolled]="isBottomScrolled"
          [showContainer]="showAssignCarrier && notshow && !loading"
          [selected]="selected"
          [shopCountry]="shopCountry"
          (onDeselectItems)="deselectItems()"
          (onOpenDialog)="openDialog()"
          [isOrdersUpdating]="isOrdersUpdating"></app-action-container>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
} @else {
  <skeleton-workspace-page [titleText]="screenTitle"></skeleton-workspace-page>
}

<ng-template #groupHeader let-group>
  <div class="group-header">
    @if (group?.rows?.length) {
      <pdq-checkbox
        [variant]="groupCheckedState()?.[group.key]?.checkVariant ?? 'hyper'"
        [stringValue]="group.key"
        [checked]="groupCheckedState()?.[group.key]?.checked"
        (onChange)="onGroupSelect($event, group)"></pdq-checkbox>
    }
    <div class="group-header--details">
      <div class="group-header--details--info">
        <div class="group-header--details-index">Group {{ group.index }}</div>
        <div class="group-header--details-count">({{ group?.rows?.length }} items)</div>
      </div>

      <div class="group-header--details--tags">
        @for (groupData of groupBy; track groupData; let i = $index) {
          <pdq-tag size="medium" variant="quaternary" mode="rounded" [padding]="false">
            <div class="group-tag">
              {{ !group?.key?.split('~')[i]?.includes('Missing') ? groupData.label + ' -' : '' }}&nbsp;
              @if (group?.rows?.length) {
                @if (groupData.value != GroupByOptions.COLOR_CODING || group?.key.split('~')[i]?.includes('Missing')) {
                  {{ group?.key.split('~')[i] }}
                } @else {
                  @for (color of group?.key.split('~')[i]?.split(','); track color) {
                    <pdq-color-tag [color]="color"></pdq-color-tag>
                  }
                }
              }
            </div>
          </pdq-tag>
        }
      </div>
    </div>
  </div>
</ng-template>

<ng-template
  #groupByTableTemplate
  let-headless="headless"
  let-headerOnly="headerOnly"
  let-footerOnly="footerOnly"
  let-tableHeight="tableHeight"
  let-displayFooter="displayFooter"
  let-allowResetFilters="allowResetFilters"
  let-collapsed="collapsed"
  let-rowsLoading="rowsLoading"
  let-rows="rows">
  <app-table
    hotKeyShortcut
    [relevantShortcuts]="keyboardShortcuts"
    [shortcutScope]="shortcutScope"
    [table]="TABLES.ASSIGN"
    [displayTableFooter]="displayFooter"
    [rows]="rows ?? []"
    [headless]="headless"
    [allowResetFilters]="false"
    [tableHeight]="tableHeight"
    [displayPickList]="true"
    [columnsSettings]="columns"
    [rowsLoading]="rowsLoading"
    [rowActions]="rowActions"
    [headerOnly]="headerOnly"
    [collapsed]="collapsed"
    [footerOnly]="footerOnly"
    [focusedRowId]="focusedOrderId"
    [groupActions]="groupActions"
    [totalCountOrders]="totalCountOrders"
    [perPageActiveOption]="ordersPerPage"
    [allPages]="allPages"
    [activePage]="activePage"
    [totalPages]="totalPages"
    [perPageOptions]="perPageOptions"
    [printOptionActions]="tablePrintActions"
    [selected]="selected"
    [isSyncingOrders]="isSyncing"
    [unHold]="unhold"
    [unSchedule]="unschedule"
    [message]="chooseEmptyMessage()"
    [tableHorizontalScrollPosition]="tableHorizontalScrollPosition()"
    [tableHorizontalCustomPositionEnabled]="true"
    (sort)="sortColumns($event)"
    (changeFilter)="onChangeTableFilter($event)"
    (changeSelectedOrders)="onSelect($event)"
    (deleteOrder)="onDeleteOrder($event)"
    (reSyncOrder)="reSyncOrderClick($event)"
    (changePerPage)="onChangeOrdersPerPage($event)"
    (changePage)="paginate($event)"
    (onHorizontalScroll)="onHorizontalScroll($event)"
    (jumpToPage)="jumpToPage($event)"
    (onTableActivate)="onTableActivate($event)"
    (reSyncSelectedOrder)="reSyncSelectedOrderClick()"
    (deleteSelectedOrder)="onDeleteSelectedOrders()"
    (toScheduleSelectedOrders)="toScheduleSelectedOrders()"
    (exportSelectedOrders)="exportSelectedOrders($event)"
    (onBulkPrint)="onBulkPrint($event)"
    (onBottomScrolled)="onBottomScrolled($event)"
    (selectOrderGroupActions)="toSelectedOrderActions($event)"
    (splitOrder)="splitOrder($event)"
    [disableGroupActions]="disableGroupActions"
    (changeLocationSelectedOrders)="changeLocationSelectedOrders($event)"
    (editPackageOrders)="editPackageOrders()"
    (mergeOrders)="mergeOrders()"
    (addTagSelectedOrders)="addTagSelectedOrders()"
    (onBulkColorCodingApply)="bulkChangeColorCoding($event)"
    (changeColorCoding)="changeColorCoding($event)"
    [paginationMode]="useCursorPagination() ? 'cursor' : 'offset'"
    [cursorRangeLabel]="deliverCursorPagination.rangeLabel()"
    [cursorHasNextPage]="deliverCursorPagination.hasNextPage()"
    [cursorHasPreviousPage]="deliverCursorPagination.hasPreviousPage()"
    [totalCountDisplay]="useCursorPagination() ? deliverCursorPagination.totalCountDisplay() : null"
    (cursorPageChange)="onCursorPageChange($event)"></app-table>
</ng-template>
